/**
 * humaninterval - Created by karora on 16/03/17.
 */

import { Pipe, PipeTransform } from '@angular/core';
/*
 * Format a number of seconds into a Human Readable interval
 */
@Pipe({name: 'humaninterval'})
export class HumanIntervalPipe implements PipeTransform {
  transform(interval: number): string {
    if (isNaN(interval)) { return '-'; }
    let seconds = interval % 60;
    interval = (interval - seconds) / 60;
    let minutes = interval % 60;
    interval = (interval - minutes) / 60;
    let hours = interval % 24;
    interval = (interval - hours) / 24;
    let days = interval;

    let result = '';
    if (days) {
      result += days + 'd';
      if (hours && days < 10) {
        result += hours + 'h';
      }
    } else {
      if (hours) {
        result += hours + 'h';
      }
      if (minutes) {
        result += minutes + 'm';
      }
      if (!hours) {
        result += seconds + 's';
      }
    }
    return result;
  }
}
